import React, { ReactElement, useEffect, useRef } from "react";
import {
  adsenseClientId,
  adsenseScenariosListBottomSlot,
  initializeAdsenseAd,
} from "../../utils/adsense";
import "./ScenariosListBottomAd.less";

export default (): ReactElement | null => {
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    initializeAdsenseAd(adRef.current);
  }, []);

  if (!adsenseClientId || !adsenseScenariosListBottomSlot) {
    return null;
  }

  return (
    <div className="scenarios-list-bottom-ad-layout">
      <div className="scenarios-list-bottom-ad-layout-inner">
        <aside className="scenarios-list-bottom-ad" aria-label="Advertisement">
          <ins
            ref={adRef}
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client={adsenseClientId}
            data-ad-slot={adsenseScenariosListBottomSlot}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </aside>
      </div>
    </div>
  );
};
